export function replaceNullsWithEmptyStrings(obj) {
  const result = {};

  for (const key in obj) {
    if (obj[key] === null) {
      result[key] = "";
    } else {
      result[key] = obj[key];
    }
  }

  return result;
}
